// PURPOSE: Keep the editable call playbook readable as its content or width changes.
// CONTRACT: Grow to content up to sixteen lines, then allow scrolling.
// DEPENDS: React and ResizeObserver; shared outreach textarea styles.
// CEILING: Local presentation only; the calling form owns persistence.
import { useLayoutEffect, useRef } from 'react';

export function CallScript({ value, onChange }: { value: string; onChange(value: string): void }) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const field = ref.current;
    if (!field) return;
    const resize = () => { field.style.height = 'auto'; field.style.height = `${field.scrollHeight + 2}px`; };
    resize();
    if (typeof ResizeObserver === 'undefined') return;
    let width = field.clientWidth;
    const observer = new ResizeObserver(() => {
      if (field.clientWidth !== width) { width = field.clientWidth; resize(); }
    });
    observer.observe(field);
    return () => observer.disconnect();
  }, [value]);
  return <textarea ref={ref} className="outreach-call-script" rows={4} aria-label="Call script" maxLength={20000} value={value.split('\n').filter(line => !/^[A-Za-z][A-Za-z ]*:\s*$/.test(line.trim())).join('\n')} onChange={event => onChange(event.target.value)} />;
}
